/**
 * Custom Modal Handler
 * Requires jQuery
 */

class CustomModal {
  constructor(modalId) {
    this.modalId = modalId;
    this.modal = $(`#${modalId}`);
    this.overlay = this.modal.find(".custom-modal__overlay");
    this.closeBtn = this.modal.find(".custom-modal__close");
    this.trigger = $(`.modal-trigger[data-modal-trigger="${modalId}"]`);
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    const escNs =
      "customModalEsc_" + this.modalId.replace(/[^a-zA-Z0-9_-]/g, "_");

    // Trigger component click
    if (this.trigger.length) {
      this.trigger.on("click", () => this.open());
    }

    // Close button click
    this.closeBtn.on("click", () => this.close());

    // Close on overlay click
    this.overlay.on("click", () => this.close());

    // Prevent closing when clicking modal content
    this.modal.find(".custom-modal__container").on("click", (e) => {
      e.stopPropagation();
    });

    // Close on ESC key (namespaced so replacing section DOM can re-init without duplicate handlers)
    $(document)
      .off("keydown." + escNs)
      .on("keydown." + escNs, (e) => {
        if (e.key === "Escape" && this.isOpen) {
          this.close();
        }
      });
  }

  open() {
    if (this.isOpen) return;

    this.isOpen = true;
    this.modal.addClass("is-active");
    $("body").css("overflow", "hidden"); // Prevent background scrolling

    // Trigger custom event
    this.modal.trigger("modal:opened");
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.modal.removeClass("is-active");
    $("body").css("overflow", "");

    // Trigger custom event
    this.modal.trigger("modal:closed");
  }

  setContent(content) {
    this.modal.find(".custom-modal__content").html(content);
  }

  setTitle(title) {
    this.modal.find(".custom-modal__title").text(title);
  }
}

window.CustomModal = CustomModal;

// Initialize modals when DOM is ready
$(document).ready(function () {
  // Create a global object to store modal instances
  window.customModals = {};

  // Initialize all modals on the page
  $(".custom-modal").each(function () {
    const modalId = $(this).attr("id");
    window.customModals[modalId] = new CustomModal(modalId);
  });
});

// Example usage:
/*
  // Create modal in liquid template
  {% render 'modal', 
    id: 'my-modal',
    title: 'My Modal Title',
    content: 'My modal content',
    width: 600,
    component: '<button class="btn">Open Modal</button>'
  %}

  // Or with custom component
  {% render 'modal',
    id: 'image-modal',
    title: 'Image Preview',
    content: '<img src="large-image.jpg">',
    component: '<img src="thumbnail.jpg" class="thumbnail">'
  %}

  // Or with another snippet as trigger
  {% render 'modal',
    id: 'product-modal',
    title: 'Quick View',
    content: product-details,
    component: {% render 'product-card', product: product %}
  %}

  // You can still open/close programmatically
  customModals['my-modal'].open();
  customModals['my-modal'].close();

  // Update content dynamically
  customModals['my-modal'].setContent('New content');

  // Update title dynamically
  customModals['my-modal'].setTitle('New title');

  // Listen for modal events
  $('#my-modal').on('modal:opened', function() {
    console.log('Modal opened');
  });

  $('#my-modal').on('modal:closed', function() {
    console.log('Modal closed');
  });
*/
